import {getSelectedCompany, getSelectedRowData} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnDownloadEmployeesInFormat = function () {

    var element = '#btn-download-employees-format';

    if (!element_exists(element)) return false;

    var btnDownload = $(element);

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    var lang = allLangFiles.employee.validation;

    btnDownload.on('click', function (e) {

        var dataTable = $('#datatable-customer-employees').DataTable();
        var selectedRowData = getSelectedRowData(dataTable);

        var flag_warning = [];

        var employee_ids = [];
        for (var i = 0; i < selectedRowData.length; i++) {
            employee_ids.push(selectedRowData[i].id);

            if (selectedRowData[i].exported_at) flag_warning.push(selectedRowData[i].first_name + ' ' + selectedRowData[i].last_name);
        }

        e.preventDefault();

        var company_id = getSelectedCompany();

        if (company_id === 'default') {

            toastr.warning(lang.company_id);
        }
        else {

            if (employee_ids.length < 1) return toastr.warning(lang.employee_id);

            if (flag_warning.length > 0) {

                var text = flag_warning.join(', ');

                $.confirm({

                    title: lang.title,
                    content: text + '<br>' + lang.confirm,
                    theme: 'supervan',
                    columnClass: 'col-md-12',
                    backgroundDismiss: true,
                    buttons: {
                        Yes: {
                            text: lang.yes,
                            action: function () {
                                downloadEmployees(company_id, employee_ids, dataTable);
                            }
                        },
                        No: {
                            text: lang.no
                        }
                    }
                });
            }
            else {
                /*TODO investigate if still not wokkring*/
                downloadEmployees(company_id, employee_ids, dataTable);
            }
        }
    });

    function downloadEmployees(company_id, employee_ids, dataTable) {
        var url = '/employees/export/' + company_id + '/' + employee_ids.join(',');

        setTimeout(function () {
            document.location.href = url;

            /*Important to set timeout so reload happens after download... otherwise table is not reloaded with new - correct data*/
            setTimeout(function () {
                dataTable.rows('.selected').deselect();
                dataTable.ajax.reload(null, false);
            }, 250);

        }, 250);


    }
};